import React, { useState, useEffect } from "react";

import { useLocation } from "react-router-dom";
import { Row, Column } from "components/Layout/Grid";
import Text from "components/Text";
import Input from "components/Input";

import iconAdd from "img/icon-add.svg";
import iconRemove from "img/icon-remove.svg";

import { PhoneNumberOutput } from "utils/PhoneNumber";
import { useEnvironment } from "hooks/useEnvironment";
import { EnvironmentTypes } from "../Description/interface";

const ContactData: React.FC<any> = (props) => {
  const {
    protocolCategory,
    office,
    setOffice
  } = props;

  const location = useLocation();

  const development = useEnvironment();
  const [technicalComplaintLayout, setTechnicalComplaintLayout] = useState(
    false
  );

  const [contactName, setContactName] = useState(
    location?.state?.contactName || ""
  );
  const [contactMailAddress, setContactMailAddress] = useState(
    location?.state?.contactMailAddress || ""
  );
  const [contactPhoneNumber, setContactPhoneNumber] = useState(
    location?.state?.contactPhoneNumber || ""
  );

  const [showAddContact, setShowAddContact] = useState(
    contactName || contactMailAddress || contactPhoneNumber || office
  );

  function AddRemoveContact(show: boolean) {
    const environment = process.env.REACT_APP_HOME_URL;
    setShowAddContact(show);

    if (!show) {
      setContactName("");
      setContactMailAddress("");
      setContactPhoneNumber("");
      setOffice("");
    } else if (development || environment === EnvironmentTypes.dev || environment === EnvironmentTypes.qas) {
      setContactName("CCare Dev");
      setContactMailAddress("dev@apinteractive.com.br");
      setContactPhoneNumber("99999999999");
      setOffice("Developer");
    }

    return false;
  }

  useEffect(() => {
    setTechnicalComplaintLayout(protocolCategory === "7");

    if (protocolCategory === "7") {
      AddRemoveContact(true);
    }
  }, [protocolCategory]);

  const textContactName = technicalComplaintLayout
    ? "Responsável pela Notificação"
    : "Nome do Contato (opcional)";

  const textIsOptional = technicalComplaintLayout ? "" : "(opcional)";

  return !showAddContact && !technicalComplaintLayout ? (
    <Row className="mt-5 align-center">
      <a onClick={() => AddRemoveContact(true)} className="d-flex" id="add-contact">
        <img src={iconAdd} alt="" style={{ width: 20, height: 20 }} />
        <Text size={14} className="color-blue-gray ml-2">
          Adicionar contato adicional para retorno do protocolo
        </Text>
      </a>
    </Row>
  ) : (
    <>
      {!technicalComplaintLayout && (
        <Row className="mt-5">
          <button onClick={() => AddRemoveContact(false)} className="d-flex" id="remove-contact">
            <img src={iconRemove} alt="" style={{ width: 20, height: 20 }} />
            <Text size={14} className="color-blue-gray ml-2">
              Remover contato
            </Text>
          </button>
        </Row>
      )}
      <Row className="mt-5 flex-md-column">
        <Column className="flex-1">
          <Text className="mb-2 color-blue-gray" size={12}>
            {textContactName}
          </Text>
          <Input
            stateName="contactName"
            onChange={(e: any) => setContactName(e.target.value)}
            className="w-100"
            type="text"
            name="Nome do contato"
            placeholder="Nome"
            value={contactName}
            required={technicalComplaintLayout}
            id="name-input"
          />
        </Column>

        <Column className="flex-1 ml-4 ml-sm-0 mt-md-2">
          <Text className="mb-2 color-blue-gray" size={12}>
            E-mail {textIsOptional}
          </Text>
          <Input
            stateName="contactMailAddress"
            onChange={(e: any) => setContactMailAddress(e.target.value)}
            className="w-100"
            type="email"
            placeholder="E-mail"
            value={contactMailAddress}
            required={technicalComplaintLayout}
            id="email-input"
          />
        </Column>

        <Column className="flex-1 ml-4 ml-sm-0 mt-md-2">
          <Text className="mb-2 color-blue-gray" size={12}>
            Telefone {textIsOptional}
          </Text>
          <Input
            stateName="contactPhoneNumber"
            onChange={(e: any) =>
              setContactPhoneNumber(PhoneNumberOutput(e.target.value))
            }
            className="w-100 w-md-100"
            type="telphone"
            placeholder="Telefone"
            value={PhoneNumberOutput(contactPhoneNumber)}
            required={technicalComplaintLayout}
            id="phone-number-input"
          />
        </Column>
        <Column className="flex-1 ml-4 ml-sm-0 mt-md-2">
          <Text className="mb-2 color-blue-gray" size={12}>
            Cargo {textIsOptional}
          </Text>
          <Input
            stateName="office"
            onChange={(e: any) => setOffice(e.target.value)}
            className="w-100"
            type="text"
            name="Cargo"
            placeholder="Cargo"
            value={office}
            required={technicalComplaintLayout}
            id="office-input"
          />
        </Column>
      </Row>
    </>
  );
};

export default ContactData;
